import { Component, Input, OnInit } from '@angular/core';
import { ToolsService } from '@huge-monorepo/hip/services';

@Component({
  selector: 'status-time-ago',
  templateUrl: './status-time-ago.component.html',
  styleUrls: ['./status-time-ago.component.scss'],
})
export class StatusTimeAgoComponent implements OnInit {
  @Input() lastPing: string;
  @Input() lastSnapshot: string;
  @Input() lastInform: string;

  pingStatus: string;
  snapshotStatus: string;
  acsStatus: string;

  pingBoolStatus: boolean = false;
  snapshotBoolStatus: boolean = false;
  acsBoolStatus: boolean = false;
  loading: boolean = true;

  constructor(private tools: ToolsService) {}

  ngOnInit() {
    setTimeout(() => {
      this.loading = true;
      this.updateOnlineStatuses();
    }, 1000);
  }

  transform(value: any): any {
    return new Date(value);
  }

  updateOnlineStatuses() {
    this.pingStatus = this.tools.checkRouterStatus(this.lastPing, 'ping');
    this.snapshotStatus = this.tools.checkRouterStatus(this.lastSnapshot, 'snapshot');
    this.acsStatus = this.tools.checkRouterStatus(this.lastInform, 'acs');

    this.pingBoolStatus = this.tools.checkRouterBoolStatus(this.pingStatus);
    this.snapshotBoolStatus = this.tools.checkRouterBoolStatus(this.snapshotStatus);
    this.acsBoolStatus = this.tools.checkRouterBoolStatus(this.acsStatus);
    this.loading = false;
  }
}
